module.exports = __webpack_public_path__ + "static/media/formule.3c5c49f1.png";